import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  private readonly _router = inject(Router);

  constructor() {
    // Ascolta i cambiamenti di rotta e riporta lo scroll in cima
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      // Usiamo setTimeout per assicurarci che il DOM della nuova pagina sia stato renderizzato
      setTimeout(() => {
        this.scrollToTop();
      }, 50);
    });
  }

  /**
   * Riporta lo scroll in cima alla pagina o al contenitore principale.
   * Può essere richiamato manualmente da qualsiasi parte del progetto.
   */
  scrollToTop(): void {
    // Cerchiamo il contenitore principale (definito nel layout)
    const mainContainer = document.getElementById('main-scroll-container');
    
    // Proviamo a scrollare il contenitore se ha un overflow interno
    if (mainContainer) {
      mainContainer.scrollTo({ top: 0, behavior: 'smooth' });
    }
    
    // Su mobile, il layout potrebbe non usare l'overflow del main ma allungare l'intero body.
    // Facciamo un fallback esplicito su window.
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    // Fallback per Safari/vecchi browser
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}
